import React, { Component } from "react";
import Select from "react-select";
import { TextareaAutosize } from "@material-ui/core";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class ModalCLV extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <legend>Certificado de libre venta</legend>
            <div className="container">
              <div className="row ">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="form-group col-lg-6">
                    <label htmlFor="producto_clv">
                      Producto: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="producto_r"
                      id="producto_r"
                      onChange={(e) =>
                        this.props.component.handleProductoRefrendado(e)
                      }
                      value={this.props.state.producto_r}
                      className="form-control"
                    >
                      <option value="">Seleccione producto</option>
                      {this.props.state.options_productos_refrendados.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.nombre_comercial}
                        </option>
                      ))}
                    </select>
                    </div>

                    <div className="form-group col-lg-6">
                    <label htmlFor="pais_clv">
                      País: <span className="text-danger"> *</span>
                    </label>

                    <Select
                      isMulti
                      styles={colourStyles}
                      placeholder="Seleccione"
                      onChange={this.props.component.handlePaises}
                      theme="neutral40"
                      value={this.props.state.paises}
                      options={this.props.state.options_countries}
                      getOptionLabel={(option) => option.descripcion}
                      getOptionValue={(option) => option.id}
                      noOptionsMessage={() =>
                        "No se encontraron paises"
                      }
                  />

                    </div>

                 
                    <div className="form-group col-lg-12">
                      <label htmlFor="causa_sancion">
                        Petición: <span className="text-danger"> *</span>
                      </label>

                        <TextareaAutosize 
                          rowsMin={2}
                          rowsMax={3}
                          name="uso"
                          value={this.props.state.peticion}
                          onChange={(e) =>
                            this.props.component.handlePeticion(e)
                          }
                          className="form-control  m-b-5"
                          placeholder=""
                        />
                    </div>

                  {/* TIPO DE ENVASE */}

 
                    <div className={(!this.props.state.es_reactivo && this.props.state.prod_seleccionado)?"form-group col-md-12":"form-group col-md-12 hide"}>
                      Presentación:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.props.component.handleEmpaqueProductoRefrendado}
                          name="empaque_id"
                          className="form-control m-b-5 "
                          value={this.props.state.rpe_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.lista_empaque_producto_refrendado.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    

                   
                    <div className={(this.props.state.es_reactivo && this.props.state.prod_seleccionado)?"form-group col-md-12":"form-group col-md-12 hide"}>
                      Presentación:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.props.component.handlePresentacionProductoRefrendado}
                          name="presentacion_id"
                          className="form-control m-b-5 "
                          value={this.props.state.rpp_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.lista_presentacion_producto_refrendado.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

              

                  

                        {/* FIN DE EXPORTACION */}
                        {/* <div className="form-group col-lg-3">
                    <label htmlFor="causa_sancion">
                      Fin de exportación: <span className="text-danger"> *</span>
                    </label>

                    <select
                        name="fin_exportacion"
                        className="form-control m-b-5"
                        value={this.props.state.fin_exportacion}
                        onChange={(e) =>
                          this.props.component.handleFinExportacion(e) //cambiar
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_fin_exportacion.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                      </div> */}

                  {/*   <div className="form-group col-lg-5">
                    <label htmlFor="causa_sancion">
                      Número de factura: <span className="text-danger"> *</span>
                    </label>

                    <input
                        type="input"
                        className="form-control"
                        //placeholder="Causa de la sanción"
                        value={this.props.state.numero_factura}
                        onChange={(e) =>
                        this.props.component.handleNumFactura(e)
                      }
                      />
                   </div> */}
              
                  <div className="form-group col-lg-12">
                    <button
                    style={{marginTop:20,paddingLeft:25,paddingRight:25}}
                      onClick={() => {
                        //MAXIMO DE SANCIONES 2
                       /*  let s_id =
                          this.props.state.tipo_sancion_id === ""
                            ? "0"
                            : this.props.state.tipo_sancion_id;
                        let s_descripcion =
                          document.querySelector("#tipo_sancion").options[
                            parseInt(s_id)
                          ].text;
                        let i_id =
                          this.props.state.tipo_infraccion_id === ""
                            ? "0"
                            : this.props.state.tipo_infraccion_id;
                        let i_descripcion =
                          document.querySelector("#tipo_infraccion").options[
                            parseInt(i_id)
                          ].text; */

                        let obj = {
                          producto_r: this.props.state.producto_r,
                          producto_name: this.props.state.producto_name,
                          paises: this.props.state.paises,
                          peticion: this.props.state.peticion,
                          rpe_id: this.props.state.rpe_id,
                          rpp_id: this.props.state.rpp_id,
                          es_reactivo: this.props.state.es_reactivo
                          //fin_exportacion: this.props.state.fin_exportacion,
                          //num_factura: this.props.state.num_factura
                        };

                         //this.props.component.handleCLV(obj);
                        this.props.component.AddCLV(obj);
                      }}
                      className="btn btn-info col-lg-12"
                    >
                      +
                    </button>
                  </div>
                  </div>
                  </div>
              </div>
            </div>

            <hr></hr>
            <div className="table-responsive">
              <table className="table table-striped m-b-0 table-hover">
                <thead>
                  <tr>
                    <th>Producto</th>
                    <th>País</th>
                    <th>Petición</th>
                    <th>Presentación</th>
                   {/*  <th>Fin de exportación</th> */}
            {/*         <th>Número de factura</th> */}
                      
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.state.productos_refrendados.length > 0 ? (
                    this.props.state.productos_refrendados.map((productos_refrendados, index) => (
                      <tr key={index} id={index}>
                        <td>{productos_refrendados.producto_name}</td>
                        <td>{productos_refrendados.pais_name}</td>
                        <td>{productos_refrendados.peticion}</td>
                        <td>{productos_refrendados.rpp_descripcion!==""?productos_refrendados.rpp_descripcion:productos_refrendados.rpe_descripcion}</td>
                       {/*  <td>{productos_refrendados.fin_exportacion_name}</td> */}
                      {/*   <td>{productos_refrendados.num_factura}</td> */}
                        
                        <td className="text-right">
                          <button
                            className="btn btn-warning remover-sancion"
                            id={index}
                            onClick={this.props.component.removeProductoRefrendado}
                          >
                            <i
                              className="fas fa-trash"
                              id={index}
                              onClick={this.props.component.removeProductoRefrendado}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td></td>
                      <td></td>
                      <td className="text-center">No existen productos</td>
                      <td></td>
                      <td></td>
                      
                     {/*  <td></td> */}
                      {/* <td></td> */}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </fieldset>
          <hr></hr>
          <fieldset>
            <legend>Justificación</legend>
            <div className="container">
              <div className="row">
                <div className="form-group col-lg-12">
                  <label htmlFor="clv">
                    Justificación: <span className="text-danger"> *</span>
                  </label>

                  <TextareaAutosize
                    rowsMin={2}
                    rowsMax={3}
                    name="Justsificacion"
                    title="Justificación"
                    value={this.props.state.justificacion}
                    onChange={(e) =>
                      this.props.component.handleJustificacion(e)
                    }
                    className="form-control m-b-5"
                    maxLength={500}
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </fieldset>
          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModalCLV(1);
                  //this.props.component.limpiarCampos(1, 0);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="button"
              onClick={() => {
                this.props.component.handleSubmit(1);
              }}
              className="btn btn-success"
            >
              Generar certificados
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalCLV;
